var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7642 20.165H2.15713C1.40529 20.165 0.795898 19.5556 0.795898 18.8038V2.1967C0.795898 1.44486 1.40529 0.835449 2.15713 0.835449H18.7642C19.516 0.835449 20.1254 1.44486 20.1254 2.1967V18.8038C20.1253 19.5556 19.5159 20.165 18.7642 20.165Z",
    fill: "#FFC549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38664 16.1381C9.10298 16.1381 8.82926 16.0253 8.62744 15.8235L3.79507 10.9911C3.3756 10.5717 3.3756 9.89209 3.79507 9.47261C4.21455 9.05314 4.89413 9.05314 5.31361 9.47261L9.27867 13.4377L15.5137 5.28413C15.8728 4.81386 16.5466 4.72209 17.0191 5.08329C17.4905 5.4435 17.5802 6.1178 17.22 6.58869L10.2398 15.7165C10.0516 15.9624 9.76685 16.115 9.45805 16.1355C9.43388 16.1375 9.41032 16.1381 9.38664 16.1381Z",
    fill: "#0D2435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.dfdad288ad35005fa2df3f59628689a9.svg";
export { ForwardRef as ReactComponent };